/**
 * @desc 验证业务单据是否存在任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<boolean>;
export function request(
  params: API.activiti.activiti.verifyBusinesskey.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/verifyBusinesskey`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
